import { MediaQueries } from 'UI'

export default (theme) => ({
  container: {
    paddingBottom: 128
  },
  linkedinContainer: {
    marginBottom: '12px'
  },
  linkedinIconClass: {
    height: '24px',
    width: '24px',
    borderRadius: '8px',
    backgroundColor: '#0E76A8',
    color: '#FFFFFF',
    fontFamily: 'Font Awesome 6 Brands',
    fontSize: '12px',
    letterSpacing: 0,
    lineHeight: '23px'
  },
  linkedinTextClass: {
    paddingLeft: '8px'
  },
  linkedinUrlClass: {
    height: '30px',
    width: '96px',
    color: '#3767DA',
    fontFamily: 'Roboto',
    fontSize: '16px',
    letterSpacing: 0,
    lineHeight: '30px',
    textDecoration: 'none'
  },
  avatarClass: {
    maxHeight: '100px !important',
    maxWidth: '100px !important',
    minHeight: '100px !important',
    minWidth: '100px !important'
  },
  rowClass: {
    marginTop: 64
  },
  cardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 8,
    marginBottom: 24
  },
  skeletonClass: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  cardClass: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 8,
    width: 154,
    height: 99,
    border: `1px solid ${theme.neutral[0]}`
  },
  [`${MediaQueries.mobile}`]: {
    container: {
      paddingBottom: 64
    },
    avatarClass: {
      maxHeight: '108px !important',
      maxWidth: '108px !important',
      minHeight: '108px !important',
      minWidth: '108px !important'
    },
    rowClass: {
      marginTop: 32
    }
  },
  [`${MediaQueries.tablet}`]: {
    container: {
      paddingBottom: 64
    },
    avatarClass: {
      maxHeight: '108px !important',
      maxWidth: '108px !important',
      minHeight: '108px !important',
      minWidth: '108px !important'
    },
    rowClass: {
      marginTop: 32
    }
  }
})
